import { atwMark, type AtwMarkId } from "@/components/Brand/atwProductMarks";
import { cn } from "@/lib/utils";

type Props = {
  id: AtwMarkId;
  /** Pixel size of the mark. */
  size?: number;
  className?: string;
  /** When true, the product name is the accessible name. Otherwise decorative. */
  label?: boolean;
  /** `inverse` turns the navy line mark white for dark surfaces. */
  tone?: "brand" | "inverse";
};

/** Line mark in the ATW diamond language for a system or application. */
export function AtwProductMark({ id, size = 40, className, label = false, tone = "brand" }: Props) {
  const mark = atwMark(id);
  return (
    <img
      src={mark.src}
      width={size}
      height={size}
      alt={label ? mark.name : ""}
      aria-hidden={label ? undefined : true}
      className={cn("shrink-0", tone === "inverse" && "brightness-0 invert", className)}
      draggable={false}
    />
  );
}
